import React, { useState } from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { urlApi } from '../Constants/Global';
import ContentHTML from './ContentHTML';

import Icon1 from '../Medias/mockup/icon/1.png';
import Icon2 from '../Medias/mockup/icon/2.png';
import Icon3 from '../Medias/mockup/icon/3.png';
import Icon4 from '../Medias/mockup/icon/4.png';
import Icon5 from '../Medias/mockup/icon/5.png';
import Icon6 from '../Medias/mockup/icon/6.png';

function SectionVision({ contents, topic }) {
  const mockup = {
    items: [
      {
        row_value: Icon1,
        set1: 'Litigation',
        set2: 'Litigation including criminal as well as civil litigation lawsuits, labor lawsuits, and international arbitration.'
      }
    ]
  };

  return (
    <section id="vision" className='bg-color-primary'>
      <Container fluid>
        <Row>
          {contents?.map((item, index) => (
            <>
              <Col xs={12} md={6} className="text-center px-0">
                <div className='bg-img w-100 h-100' style={{ backgroundImage: `url(${urlApi}/storage/media/${item.set3})`, minHeight: '300px' }}></div>
              </Col>
              <Col xs={12} md={5} className='px-0 px-md-5'>
                <div className='p-5 px-5 px-md-5 text-white'>
                  <h1 className='font-header mt-5 mb-5'><span className='font-header tx-color-secondary'>Our</span> Vision</h1>
                  <ContentHTML htmlContent={item.set2} />
                </div>
              </Col>
            </>
          ))}
        </Row>
      </Container>
    </section >
  )
}

SectionVision.defaultProps = {
  contents: [],
  topic: []
}

export default SectionVision